<template>
  <div>
    <div>
      <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
      <h3 class="mt-3">
        {{
          $getVisibleNames(
            "teaching.evaluationsituation",
            false,
            "Situación Evaluativa"
          )
        }}
        <AlternativeNameButton
          :table_name="'teaching.evaluationsituation'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'teaching.add_evaluationsituation'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'teaching.evaluationsituation',
                  false,
                  'Situación Evaluativa'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="
              () => $bvModal.show(`new-evaluation_situation-modal`)
            "
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
        </div>
      </div>
      <GenericBTable
        :items="evaluation_situations"
        :pagination="evaluation_situations.length"
        :fields="evaluation_situationsFields"
        :filter="input_search"
        :filterCustom="filterCustom"
        @emitChangeSearchField="changeInputSearch"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template> </template>
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'teaching.evaluationsituation',
                  false,
                  'Situación Evaluativa'
                ),
              })
            "
            :click_button="
              () =>
                $bvModal.show(`edit-evaluation_situation-modal-${row.item.id}`)
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <span
            v-if="
              institution &&
              institution.internal_use_id == 'duoc.cl' &&
              row.item.internal_use_id != null
            "
            v-b-tooltip.v-secondary.auto.noninteractive="
              $t('curricularDefinitions.modality.requiredForDidacticBriefcase')
            "
          >
            <ButtonSmall
              :disabled_button="true"
              :tooltip_text="``"
              :icon="'trash'"
            ></ButtonSmall>
          </span>
          <ButtonSmall
            v-else
            :click_button="() => askForDeleteEvaluationSituation(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'teaching.evaluationsituation',
                  false,
                  'Situación Evaluativa'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-evaluation_situation-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'teaching.evaluationsituation',
                  false,
                  'Situación Evaluativa'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <EvaluationSituationForm
              :EvaluationSituation="row.item"
              @updated="slotUpdatedEvaluationSituation"
            ></EvaluationSituationForm>
          </b-modal>
        </template>
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
      </GenericBTable>
    </div>
    <b-modal
      :id="`new-evaluation_situation-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'teaching.evaluationsituation',
            false,
            'Situación Evaluativa'
          ),
        })
      "
      size="lg"
    >
      <EvaluationSituationForm
        @created="slotCreatedEvaluationSituation"
      ></EvaluationSituationForm>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "EvaluationSituationView",
  components: {
    EvaluationSituationForm: () =>
      import(
        "@/components/mesh/CurricularResources/EvaluationSituation/EvaluationSituationForm"
      ),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {},
  data() {
    return {
      sortBy: "",
      evaluation_situations: [],
      sortDesc: false,
      input_search: "",
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
    }),
    breadcrumb_items() {
      return [
        {
          text: this.$t("reusable.breadcrumb.home"),
          to: "/home",
        },
        {
          text: this.$getVisibleNames(
            "teaching.evaluationsituation",
            false,
            "Situación Evaluativa"
          ),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions(
        "teaching.add_evaluationsituation"
      );
      if (has_permission) return has_permission;
      else return false;
    },
    evaluation_situationsFields() {
      if (!this.allows_crud)
        return this.evaluation_situations_fields.filter(
          (field) => !field.requires_allows_crud
        );
      else return this.evaluation_situations_fields;
    },
    evaluation_situations_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "teaching.evaluationsituation",
              true,
              "Situación Evaluativas"
            )
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: String(this.$t("reusable.common.description")),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    filterCustom(row) {
      if (
        this.$filtered(row.name, this.input_search) ||
        this.$filtered(row.description, this.input_search)
      ) {
        return true;
      } else {
        return false;
      }
    },
    askForDeleteEvaluationSituation(evaluation_situation_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "teaching.evaluationsituation",
            false,
            "Situación Evaluativa"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$restful
            .Delete(
              `/teaching/evaluation-situation/${evaluation_situation_id}/`
            )
            .then(() => {
              const index = this.evaluation_situations.findIndex(
                (x) => x.id == evaluation_situation_id
              );
              if (index != -1) {
                this.evaluation_situations.splice(index, 1);
                toast(
                  String(
                    this.$getVisibleNames(
                      "teaching.evaluationsituation",
                      false,
                      "Situación Evaluativa"
                    ) +
                      " " +
                      this.$t("reusable.common.deleted")
                  )
                );
              }
            });
        }
      });
    },
    fetchEvaluationSituations() {
      this.$restful.GetAll(`/teaching/evaluation-situation/`).then((response) => {
        this.evaluation_situations = response;
      });
    },
    slotCreatedEvaluationSituation(evaluation_situation) {
      this.evaluation_situations.push(evaluation_situation);
      this.$bvModal.hide("new-evaluation_situation-modal");
    },
    slotUpdatedEvaluationSituation(evaluation_situation) {
      const index = this.evaluation_situations.findIndex(
        (x) => x.id == evaluation_situation.id
      );
      if (index != -1) {
        this.evaluation_situations[index].description =
          evaluation_situation.description;
        this.evaluation_situations[index].name = evaluation_situation.name;
        this.evaluation_situations[index].update_date =
          evaluation_situation.update_date;
        this.evaluation_situations[index].updated_by =
          evaluation_situation.updated_by;
        this.$bvModal.hide(
          `edit-evaluation_situation-modal-${evaluation_situation.id}`
        );
      }
    },
  },
  mounted() {
    this.fetchEvaluationSituations();
  },
  created() {},
};
</script>

<style scoped>
th {
  background-color: var(--primary-color);
  border-radius: 6px;
  box-shadow: 1px 1px 3px rgb(72, 72, 72);
}

.title-header {
  padding: 0;
  margin-top: auto;
}
.search-evaluation_situation {
  max-width: 50rem;
  margin-left: auto;
  margin-right: 18.5%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.edit-section {
  margin-top: -2%;
}
</style>